import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
  useRouter,
} from 'expo-router';
import useAccountDetails from 'features/accounts/hooks/useAccountDetails';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlatList, StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import EmptyStateScreen from 'shared/patterns/vxl/EmptyStateScreen/EmptyStateScreen';
import ErrorScreen from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import ScreenTransitionOverlay from 'shared/patterns/vxl/ScreenTransitionOverlay/ScreenTransitionOverlay';
import theme from 'shared/styles/theme';

import TransactionList from './TransactionList';

const AdvanceHistory = () => {
  const router = useRouter();
  const { id } = useLocalSearchParams<{ id: string }>();
  const { bottom } = useSafeAreaInsets();

  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'advanceDetails',
  });
  const { loading, errorModel, pastAdvances } = useAccountDetails(id);

  const handleTransactionDetails = (nodeId: string) => {
    router.push({
      pathname: '/accounts/advance-details/advance-history',
      params: {
        id,
        transactionId: nodeId,
      },
    });
  };
  const advanceHistory = pastAdvances?.edges ?? [];

  return (
    <View style={[styles.screen, { paddingBottom: bottom }]}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: translatedText('listItems.advanceHistory'),
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />

      {advanceHistory.length > 0 ? (
        <FlatList
          data={advanceHistory}
          renderItem={({ item, index }) => (
            <TransactionList
              item={item}
              advanceHistory={advanceHistory}
              index={index}
              handleTransactionDetails={handleTransactionDetails}
              analyticsId="vaTransactionClicked"
              customAttributes={{
                account_type: 'advance',
                amount: item.node.amount.amount as string,
              }}
            />
          )}
          keyExtractor={(item) => item.node.id}
          removeClippedSubviews={false}
        />
      ) : (
        <EmptyStateScreen
          bodyText={translatedText('listItems.noHistoryBody')}
          headlineText={translatedText('listItems.noHistoryTitle')}
          illustrationKey="CASH_A"
        />
      )}

      <ScreenTransitionOverlay
        isLoading={loading}
        LoadingComponent={<LoadingSpinner />}
        ErrorComponent={
          errorModel && !loading ? <ErrorScreen {...errorModel} /> : null
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default AdvanceHistory;
